import * as React from 'react';
import Button from '@telia-front/button';
import Grid, { GridColumn } from '@telia-front/grid';
import PropsChecker from '@telia-front/props-checker';
import HeaderNavItem from '../header-nav-item/header-nav-item';
const HeaderNav = (props) => {
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "HeaderNav", defaultValueName: "defaultTree", valueName: "tree", onChangeNames: "onTreeChange" },
        React.createElement(PropsChecker, { componentProps: props, componentName: "HeaderNav", defaultValueName: "defaultSecondaryTree", valueName: "secondaryTree", onChangeNames: "onSecondaryTreeChange" },
            React.createElement(HeaderNavInner, Object.assign({}, props)))));
};
export default HeaderNav;
const closeBranches = (branch) => {
    return branch.map(item => {
        return Object.assign(Object.assign({}, item), { isOpen: false });
    });
};
class HeaderNavInner extends React.Component {
    constructor(props) {
        super(props);
        this.handleBlur = (event) => {
            // close subnavigations when focus leaves nav
            if (event.relatedTarget instanceof Node && !event.currentTarget.contains(event.relatedTarget)) {
                const secondaryTree = closeBranches(this.secondaryTree || []);
                const tree = closeBranches(this.tree || []);
                this.onTreeChange(tree);
                this.onSecondaryTreeChange(secondaryTree);
                if (this.props.onItemToggle) {
                    this.props.onItemToggle(false);
                }
            }
        };
        this.renderItem = (item) => {
            return (React.createElement(HeaderNavItem, Object.assign({ key: item.id }, item, { isOpen: !!item.isOpen, onClick: event => {
                    if (item.onClick) {
                        item.onClick(event);
                    }
                    this.props.onItemClick(event.currentTarget);
                }, onToggle: (isOpen) => {
                    if (item.onToggle) {
                        item.onToggle(isOpen);
                    }
                    this.handleItemToggle(item, isOpen);
                }, dropdownContainer: this.props.dropdownContainer, onMegamenuDropdownTransitionExited: this.props.onMegamenuDropdownTransitionExited, onMegamenuDropdownTransitionEntered: this.props.onMegamenuDropdownTransitionEntered })));
        };
        this.renderQuickAccessButton = (props) => (React.createElement("li", { className: "header__nav-item-button-container" },
            React.createElement(Grid, { align: ['center-xs'] },
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(Button, Object.assign({}, props, { className: "header__nav-item-button" }))))));
        this.state = {
            secondaryTree: props.defaultSecondaryTree || [],
            tree: props.defaultTree || [],
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen && prevProps.isOpen === true) {
            const nextTree = this.isAnySubNavOpen() ? closeBranches(this.tree) : this.tree;
            const nextSecondaryTree = this.isAnySubNavOpen() ? closeBranches(this.secondaryTree) : this.secondaryTree;
            this.onTreeChange(nextTree);
            this.onSecondaryTreeChange(nextSecondaryTree);
        }
    }
    get tree() {
        return this.isTreeControlled(this.props.tree) ? this.props.tree : this.state.tree;
    }
    isTreeControlled(value = this.props.tree) {
        return !!this.props.onTreeChange && typeof value !== 'undefined';
    }
    onTreeChange(nextTree) {
        if (this.tree !== nextTree) {
            if (!this.isTreeControlled()) {
                this.setState({
                    tree: nextTree,
                });
            }
            if (this.props.onTreeChange) {
                this.props.onTreeChange(nextTree);
            }
        }
    }
    get secondaryTree() {
        return this.isSecondaryTreeControlled(this.props.secondaryTree) ? this.props.secondaryTree : this.state.secondaryTree;
    }
    isSecondaryTreeControlled(value = this.props.secondaryTree) {
        return !!this.props.onSecondaryTreeChange && typeof value !== 'undefined';
    }
    onSecondaryTreeChange(nextSecondaryTree) {
        if (this.secondaryTree !== nextSecondaryTree) {
            if (!this.isSecondaryTreeControlled()) {
                this.setState({
                    secondaryTree: nextSecondaryTree,
                });
            }
            if (this.props.onSecondaryTreeChange) {
                this.props.onSecondaryTreeChange(nextSecondaryTree);
            }
        }
    }
    isAnySubNavOpen(tree = this.tree, secondaryTree = this.secondaryTree) {
        const isPrimaryNavOpen = !!tree.filter(item => {
            return item.isOpen;
        }).length;
        const isSecondaryNavOpen = !!secondaryTree.filter(item => {
            return item.isOpen;
        }).length;
        return isPrimaryNavOpen || isSecondaryNavOpen;
    }
    getToggledTree(tree, item, nextIsOpen = true) {
        const newTree = closeBranches(tree);
        if (!item.isOpen) {
            return newTree.map(treeItem => {
                if (treeItem.id === item.id) {
                    return Object.assign(Object.assign({}, treeItem), { isOpen: nextIsOpen });
                }
                return treeItem;
            });
        }
        return newTree;
    }
    handleItemToggle(item, nextIsOpen) {
        if (item.children) {
            const secondaryTree = this.getToggledTree(this.secondaryTree || [], item, nextIsOpen);
            const tree = this.getToggledTree(this.tree || [], item, nextIsOpen);
            this.onTreeChange(tree);
            this.onSecondaryTreeChange(secondaryTree);
            if (this.props.onItemToggle) {
                this.props.onItemToggle(nextIsOpen);
            }
        }
    }
    renderSecondary(separatorPosition) {
        if (this.secondaryTree.length) {
            const separator = (React.createElement("li", { className: "header__nav-items-separator-container", role: "presentation" },
                React.createElement("div", { className: "header__nav-items-separator" })));
            return (React.createElement(React.Fragment, null,
                separatorPosition === 'before' && separator,
                this.secondaryTree.map((item) => this.renderItem(item)),
                separatorPosition === 'after' && separator));
        }
    }
    render() {
        return (React.createElement("nav", { className: "header__nav", id: "header-nav", onBlur: this.handleBlur, "aria-label": this.props.label },
            React.createElement("ul", { className: "header__nav-list" },
                this.props.secondaryItemsBefore && this.renderSecondary('after'),
                this.tree.map((item) => this.renderItem(item)),
                !this.props.secondaryItemsBefore && this.renderSecondary('before'),
                this.props.quickAccessButton && this.renderQuickAccessButton(this.props.quickAccessButton))));
    }
}
